var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7537 2.34325C10.7587 -0.781083 5.90314 -0.781083 2.90812 2.34325C-0.0867122 5.46739 -0.0865317 10.5324 2.90848 13.6567C5.90332 16.7811 10.7589 16.7811 13.7535 13.6569C16.7485 10.5324 16.7487 5.46739 13.7537 2.34325ZM12.74 3.40076C14.8319 5.58299 15.1248 8.93004 13.622 11.4406L5.03306 2.48087C7.43954 0.912777 10.6477 1.21815 12.74 3.40076ZM3.9224 12.599C1.83013 10.4166 1.5374 7.06994 3.04005 4.55955L11.6288 13.5191C9.22247 15.0868 6.01431 14.7815 3.9224 12.599Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedTicket);
export default __webpack_public_path__ + "static/media/closed-ticket.6f32a678936ac2ef5f0eb2a3133a926e.svg";
export { ForwardRef as ReactComponent };